/**
 * Утилиты для сохранения и загрузки диапазона дат из localStorage
 */

const STORAGE_KEY = 'martin_geo_starts_date_range';
const DEFAULT_DATE_RANGE = {
    minDate: '2025-10-01',
    maxDate: '2025-10-31',
};

/**
 * Получить сохраненный диапазон дат из localStorage
 * @returns {Object} {minDate, maxDate} или DEFAULT_DATE_RANGE если не сохранено
 */
export function getSavedDateRange () {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved) {
            const parsed = JSON.parse(saved);
            // Валидировать структуру
            if (parsed.minDate && parsed.maxDate && typeof parsed.minDate === 'string' && typeof parsed.maxDate === 'string') {
                return parsed;
            }
        }
    } catch (err) {
        console.warn('[DateRangeStorage] Error reading from localStorage:', err);
    }

    return DEFAULT_DATE_RANGE;
}

/**
 * Сохранить диапазон дат в localStorage
 * @param {Object} dateRange - {minDate, maxDate}
 */
export function saveDateRange (dateRange) {
    try {
        if (dateRange && dateRange.minDate && dateRange.maxDate) {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(dateRange));
        }
    } catch (err) {
        console.warn('[DateRangeStorage] Error writing to localStorage:', err);
    }
}

/**
 * Очистить сохраненный диапазон дат
 */
export function clearSavedDateRange () {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch (err) {
        console.warn('[DateRangeStorage] Error removing from localStorage:', err);
    }
}
